import { createSelector } from 'reselect';
import { AdminState } from './type';

export const superAdminSelector = (state: any): AdminState => state.auth?.admin || {};

export const isSuperAdminSelector = createSelector(superAdminSelector, admin => admin.isSuperAdmin);

export const superAdminRoleSelector = createSelector(superAdminSelector, admin => admin.role);
